<template>
  <a-space direction="vertical" :size="20" class="container">
    <upload-area v-model:calcLoading="calcLoading" @get-file-url="finishSelect" />

    <h3 class="tips">
      <cloud-download-outlined style="margin-right: 10px" />为了保证数据导入顺利，推荐您下载使用
      
      <a-button v-if="modelUrl&&modelUrl!=''" type="link" class="template-link" :href="modelUrl">导入模版</a-button
      >
      <download-template-btn v-else :template-key="templateKey">导入模版</download-template-btn>，并按照规范示例录入数据。
    </h3>

    <div class="standard">
      <slot name="standard"></slot>
    </div>
  </a-space>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "SelectFile",
});
</script>

<script lang="ts" setup>
import { ref, computed } from "vue";
import UploadArea from "@/views/organization/component/multiple-import/upload-area/index.vue";
import { CloudDownloadOutlined } from "@ant-design/icons-vue";

const props = defineProps({
  loadingRequest: {
    type: Boolean,
    default: false,
  },
  modelUrl: {
    type: String,
  },
  templateKey:{
    type: String,
  }
});

const emit = defineEmits(["finishUpload"]);

const uploading = ref(false);

const calcLoading = computed({
  get() {
    return props.loadingRequest && uploading.value;
  },
  set(val: boolean) {
    uploading.value = val;
  },
});

function finishSelect(url) {
  url && emit("finishUpload", url);
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: calc(100% - 72px);
  padding: 0 24px;
  box-sizing: border-box;
  overflow-y: auto;
  .template-link {
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    line-height: unset;
    height: auto;
  }
  .tips {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 0;
  }

  .standard {
    color: rgba(0, 0, 0, 0.45);
    overflow: hidden;
    > p {
      margin-bottom: 10px;
    }
  }
}
</style>
